<template>
    <div class="row mb-3">
        <div class="col-sm-12 col-md-12">
            <ul class="warranty-submenu">
                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsRequestWarranty'}">
                        Warranty Requests
                    </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsActiveWarranty'}">
                        Active Warranties
                    </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'SuperadminRegisteredProductsClosedWarranty'}">
                        Closed Warranties
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WarrantySubNav',
    components: {},
    data() {
        return {};
    }
};
</script>
